module.exports = __webpack_public_path__ + "static/media/ricariche_television_digitali.9de41fa5.png";